/** The canonical-token vocabulary rule, shared by the alias editor and the
 *  tag-condition widget.
 *
 *  Lives here rather than in `api/tagNameAliases` because TagConditionInput
 *  deliberately imports no API modules, and duplicating the rule is how the two
 *  surfaces would end up disagreeing about what a valid token is.
 *
 *  Mirrors CANONICAL_TOKEN_RE in demo/lib/tag_conditions.py. The point of the
 *  constraint: a canonical is a governed token, so "Viator.com" is an alias OF
 *  one, never a canonical itself. */
export const CANONICAL_TOKEN_RE = /^[a-z0-9][a-z0-9_-]*$/;

export const CANONICAL_TOKEN_MAX_LEN = 128;

export const CANONICAL_TOKEN_HINT =
  'Lowercase letters, digits, "_" and "-" only, starting with a letter or digit.';

/** `null` when `token` is a well-formed canonical, else why it is not. */
export function canonicalTokenError(token: string): string | null {
  const value = token.trim();
  if (!value) return 'A canonical token is required.';
  if (value.length > CANONICAL_TOKEN_MAX_LEN) {
    return `Canonical token too long (max ${CANONICAL_TOKEN_MAX_LEN}).`;
  }
  return CANONICAL_TOKEN_RE.test(value.toLowerCase()) ? null : CANONICAL_TOKEN_HINT;
}
